module.exports = __webpack_public_path__ + "static/media/app_download_round_shape.44c71249.png";